export default {
    it: {
        name: "Nome",
        pin: "Metti in evidenza",
        unpin: "Rimuovi evidenza",
        reload: "Aggiorna",
        loadingReportAndAnalysis: "Caricamento...",
        unselect: "Deseleziona tutto",
        selectPage: "Seleziona pagina",
        download: "Scarica",
        logout: "Logout",
        sortBy: "Ordina per:",
        filterBy: "Filtra per:",
        close: "Chiudi",
        cancel: "Annulla",
        apply: "Applica",
        search: "Cerca",
        searchByTitle: "Cerca per titolo",
        open: "Apri",
        share: "Condividi",
        shareAll: "Condividi a tutti",
        filter: "Filtra",
        clearFilter: "Cancella filtri",
        create: "Crea",
        add: "Aggiungi",
        rename: "Rinomina",
        modify: "Modifica",
        confirm: "Conferma",
        selectAll: "Seleziona tutto",
        sorted: "Ordinamento",
        selectDate: "Seleziona Data",
        export: "Esporta",
        noData: "Nessun elemento da visualizzare",
        noDataSuggestion: "Prova a modificare i filtri di ricerca.",
        save: "Salva",
        projects: "Progetti",
        next: "Avanti",
        back: "Indietro",
        choose: "Scegli",
        analyze: "Analizza",
        title: "Titolo",
        description: "Descrizione",
        frequency: "Frequenza",
        delete: "Elimina",
        fieldRequired: "Campo obbligatorio",
        emailRequired: "L'email deve essere valida",
        fieldTooLong: "Campo troppo lungo",
        experimental: "Beta",
        selected: "Selezionato",
        page: "Pagina",
        pageOf: "di",
        totalRows: "Righe totali",
        enable: "Abilita",
        disable: "Disabilita",
        showAdvanceOptions: "Mostra opzioni avanzate",
        general: "Generale",
        security: "Sicurezza",
        strongConfirmationText: "Digita la parola",
        strongConfirmationSubtext: "nell'area sottostante per confermare di aver compreso l'azione",
        sharedWithMe: "Condivisi con me",
        owned: "Creati",
        about: {
            title: "Informazioni",
            name: "Applicazione",
            version: "Versione",
            commit: "Codice versione",
            buildTime: "Data build",
            buildId: "Build ID",
            upToDate: "Stai usando la versione più recente",
            updateAvailable: "È disponibile una nuova versione",
            checking: "Verifica aggiornamenti...",
            checkNow: "Verifica aggiornamenti",
            copy: "Copia informazioni",
            copied: "Copiato!"
        },
        account: {
            title: "Account",
            email: "Email",
            name: "Nome",
            surname: "Cognome",
            language: "Lingua",
            defaultProject: "Progetto predefinito",
            enabled: "Abilitato",
            disabled: "Disabilitato",
            create: "Crea account",
            search: "Cerca account",
            created: "Creato il",
            firstLoginOk: "Accesso effettuato",
            firstLoginNotOk: "Accesso non effettuato",
            generalSettings: "Impostazioni generali utente",
            securitySettings: "Impostazioni sulla sicurezza",
            softwareToken: {
                enableTitle: "Attivazione MFA tramite app di autenticazione",
                enable: "Abilita MFA",
                disableTitle: "Disabilita MFA tramite app di autenticazione",
                disableText:
                    "Stai per disabilitare l'autenticazione a due fattori. Questa operazione ridurrà la sicurezza del tuo account, rendendolo più vulnerabile agli accessi non autorizzati. Potrai riattivare l'autenticazione a due fattori in qualsiasi momento dalle impostazioni di sicurezza.",
                title: "App di autenticazione",
                subtitle:
                    "Utilizza un'app di autenticazione o un'estensione del browser per ottenere i codici di autenticazione a due fattori quando richiesto",
                enabledAtDate: "Abilitato il",
                deviceName: "Nome del dispositivo",
                setupTitle:
                    "Aumenta la sicurezza del tuo account attivando l'autenticazione a due fattori. Oltre alla tua password, dovrai inserire un codice di verifica generato dalla tua app di autenticazione ogni volta che effettui l'accesso. Segui questi semplici passaggi per completare la configurazione",
                qrValue: "Chiave segreta",
                qrUrl: "URL",
                scanQr: "Scansione QR Code",
                scanQrSubtitle:
                    "Utilizza un'app di autenticazione (Google Authenticator o Microsoft Authenticator o qualsiasi altra app) compatibile TOTP per scansionare il codice QR qui a fianco. L'app genererà automaticamente i codici di verifica necessari per accedere al tuo account.",
                deviceNaming: "Assegna un nome al dispositivo",
                deviceNamingSubtitle:
                    'Dai un nome riconoscibile al dispositivo o all\'app che stai configurando (ad esempio: "iPhone di Mario", "Google Authenticator", "Tablet aziendale"). Questo ti aiuterà a identificare facilmente questo metodo di autenticazione',
                deviceNamingPlaceholder: "Smartphone aziendale",
                verifyDevice: "Verifica il dispositivo",
                verifyDeviceSubtitle:
                    "Inserisci il codice di 6 cifre generato dalla tua app di autenticazione per completare la configurazione. Il codice si rinnova ogni 30 secondi, quindi assicurati di inserirlo prima che scada."
            }
        },
        language: {
            it: "Italiano",
            en: "English"
        },
        dialog: {
            title: "Titolo"
        },
        confirmDialog: {
            title: "Conferma",
            question: "Sei sicuro di procedere? Attenzione, l'azione potrebbe essere irreversibile."
        },
        workspaces: {
            info: "Scegli il progetto in cui entrare",
            title: "Progetti",
            in: "Sei nel progetto:",
            created: "Creato il:",
            sortCreated: "Data creazione",
            lastUpload: "Ultimo caricamento",
            name: "Nome",
            description: "Descrizione",
            noDataMessage: "Non hai nessun progetto che rispetti i parametri di ricerca",
            noWorkspace: "Stiamo preparando il tuo progetto...",
            create: "Crea progetto",
            modify: "Modifica progetto"
        },
        notifications: {
            title: "Notifiche",
            readAll: "Leggi tutto",
            goToReport: "Vai al report ",
            goToVault: "Vai all'archivio ",
            name: "Titolo",
            created: "Data",
            isIn: "Presenti in",
            subtitles: {
                REPORT_SHARED: "Un report è stato condiviso con te",
                VAULT_SHARED: "Hai un nuovo archivio da visualizzare"
            },
            noDataMessage: "Non hai nessuna notifica che rispetti i parametri di ricerca"
        },
        reports: {
            all: {
                title: "Tutti i report",
                shortTitle: "Tutti",
                info: "Visualizza tutti i report nell'area di lavoro"
            },
            my: {
                title: "I miei report",
                shortTitle: "I miei report",
                info: "Visualizza e crea i tuoi report di analisi"
            },
            shared: {
                title: "Report condivisi con me",
                shortTitle: "Condivisi con me",
                info: "Consulta i report che ti hanno condiviso altri utenti"
            },
            title: "Report",
            info: "Visualizza e crea i report di analisi",
            search: "Cerca report",
            createdFrom: "Data",
            create: "Crea report",
            createFromActive: "Da report attivi",
            modify: "Rinomina",
            reschedule: "Nuova versione",
            replace: "Modifica",
            youAreTheAuthor: "Sei l'autore di questo report",
            writtenBy: "Scritto da",
            createdOn: "Creato il",
            statuses: {
                title: "Stato",
                CREATED: "Creato",
                IN_PROGRESS: "In lavorazione",
                FAILED: "In revisione",
                descriptions: {
                    IN_PROGRESS: "Il report è in lavorazione. Attendi qualche istante.",
                    FAILED: "Ooops... si è verificato un errore. I nostri tecnici sono al lavoro per risolvere il problema al più presto."
                }
            },
            selectorDialog: {
                firstStep: {
                    title: "Seleziona il tipo di analisi",
                    subTitle: "Scegli il tipo di analisi di cui hai bisogno"
                },
                secondStep: {
                    title: "Imposta i parametri",
                    subTitle: "Imposta i parametri per personalizzare la tua analisi",
                    resetParameters: "Reset parameteri"
                }
            },
            printPdf: "Scarica PDF",
            printPdfNotFound: "La versione PDF di questo report sará disponibile a breve",
            delete: {
                title: "Elimina report",
                question: "Vuoi eliminare il report? Attenzione, l'azione è irreversibile!"
            },
            noDataMessage: "Non hai nessun report da visualizzare che rispetti i parametri di ricerca",
            comments: "Commenti",
            options: "Opzioni",
            scrollToTop: "Vai all'inizio",
            saveParameters: "Memorizza parametri",
            sortTitle: "Titolo",
            sortCreated: "Data creazione",
            viewGrid: "Visualizza a griglia",
            viewList: "Visualizza a lista",
            views: "visualizzazione | visualizzazioni",
            noViews: "Nessuna visualizzazione",
            noDescription: "Nessuna descrizione",
            newShaperAi: "Crea un report con Shaper AI",
            noReportV2Content: "Il report è vuoto.",
            noReportV2ContenteSuggestion: "Utilizza la chat laterale per generare dei contenuti.",
            chat: {
                name: "AI Chat",
                open: "Apri chat",
                close: "Chiudi chat",
                empty: "Non ci sono messaggi da visualizzare",
                placeholder: "Chiedi a Shaper...",
                fileSizeError:
                    "I seguenti files superano la dimensione massima di 10 MB e non sono stati caricati: {files}",
                fileTypeError: "I seguenti file non sono in formato PDF e non sono stati caricati: {files}",

                attachments: {
                    selectTitle: "Selezione allegati",
                    selectVault: "Seleziona archivio",
                    selectVaultSubtitle:
                        "Seleziona un archivio per cercare il file da caricare come allegato nella chat.",
                    selectAttachment: "Seleziona allegato/i",
                    selectAttachmentSubtitle: "Seleziona uno o piu' file da caricare come allegato nella chat.",
                    attachment: "Allegato | Allegati",
                    review: "Verifica selezione",
                    reviewSubtitle: "Controlla la selezione di allegati prima di inviarli nella chat."
                }
            },
            noMoreReports: "Non ci sono report da visualizzare"
        },
        vaults: {
            all: {
                title: "Tutti gli archivi",
                shortTitle: "Tutti",
                info: "Carica e consulta tutti i documenti nell'area di lavoro"
            },
            my: {
                title: "I miei archivi",
                shortTitle: "I miei archivi",
                info: "Carica e consulta i documenti negli archivi creati da te"
            },
            shared: {
                title: "Archivi condivisi con me",
                shortTitle: "Condivisi con me",
                info: "Carica e consulta i documenti negli archivi che ti hanno condiviso altri utenti"
            },
            title: "Archivi",
            info: "Carica e consulta i tuoi documenti",
            vault: "Archivio | Archivi",
            search: "Cerca archivi",
            searchInVault: "Cerca nell'archivio",
            create: "Crea archivio",
            modify: "Modifica archivio",
            lastModified: "Ultima modifica",
            lastUpload: "Ultimo caricamento",
            uploaded: "Caricato il",
            name: "Nome",
            description: "Descrizione",
            noDescription: "Nessuna descrizione",
            creationDate: "Data creazione",
            size: "Dimensione",
            state: "Stato",
            noVaults: "Non hai nessun archivio da consultare che rispetti i parametri di ricerca",
            downloadVault: "Scarica archivio",
            deleteVaultTitle: "Elimina archivio",
            deleteVaultText: "Vuoi eliminare questo archivio? Attenzione, l'azione è irreversibile!",
            dragAndDrop: "Trascina i file nella tabella per iniziare a caricare",
            deleteFileTitle: "Elimina elemento",
            deleteFileText: "Vuoi eliminare gli elementi selezionati? Attenzione, l'azione è irreversibile!",
            elements: "elementi",
            runTagger: "Avvia estrazione",
            noDocuments: "Questo archivio non contiene documenti",
            deleteDenied: "Non puoi cancellare l'archivio se contiene dei file",
            noMoreVaults: "Non ci sono archivi da visualizzare"
        },
        tags: {
            title: "Tag",
            GENERAL: "GENERALE",
            TLC_FIXED: "TLC FISSA",
            TLC_MOBILE: "TLC MOBILE",
            ELECTRICITY: "ELETTRICITÀ",
            GAS: "GAS",
            WATER: "ACQUA",
            CLEANING: "PULIZIE",
            MATERIAL: "MATERIALI",
            TRANSPORT: "TRASPORTI",
            HUMAN_RESOURCES: "HR",
            HUMAN_RESOURCES_INPS: "INPS",
            HUMAN_RESOURCES_INAIL: "INAIL",
            WAREHOUSE: "MAGAZZINO",
            LOGISTIC: "LOGISTICA",
            WASTE_DISPOSAL: "SMALTIMENTO RIFIUTI",
            CAR_FLEET: "PARCO AUTO",
            SUSTAINABILITY: "SOSTENIBILITÀ",
            ELECTRICITY_GAS: "ENERGIE",
            AI: "AI",
            AI_ELECTRICITY: "AI ELETTRICITÀ",
            AI_GAS: "AI GAS",
            AI_TRANSPORT: "AI TRASPORTI",
            AI_TLC: "AI TLC",
            AI_INPS: "AI INPS",
            AI_INAIL: "AI INAIL"
        },
        files: {
            info: "Visualizza e carica i file nell'archivio",
            ready: "Non ci sono file pronti per l'estrazione | Il file e' pronto per l'estrazione | {n} file sono pronti per l'estrazione",
            tagging:
                "Non ci sono file in coda per l'estrazione | il file e' in coda per l'estrazione | {n} file sono in coda per l'estrazione",
            error: "Non ci sono file in errore | Il file ha generato un errore in fase di estrazione | {n} file hanno generato un errore in fase di estrazione",
            archived:
                "Non ci sono file archiviati | Il file e' consultabile nell'archivio | {n} file sono consultabili nell'archivio",
            indexed:
                "Non ci sono file disponibili per le analisi | I dati nel file sono pronti per essere analizzati | I dati in {n} file sono pronti per essere analizzati",
            indexing:
                "Non ci sono file in fase di estrazione | Stiamo estraendo i dati da un file | Stiamo estraendo i dati da {n} file",
            createFolder: "Crea cartella",
            renameFolder: "Rinomina cartella",
            folderName: "Nome cartella",
            upload: "Carica",
            preparingFiles: "Sto preparando i file per il caricamento",
            emptyFolder: "Questa cartella e' vuota",
            note: "Tag",
            updateNote: "Imposta tag",
            multipleNotes: "Valori multipli",
            setStatus: {
                archived: "Imposta come archiviati",
                indexed: "Imposta come indicizzati",
                indexing: "Imposta come in indicizzazione"
            },
            uploadDenied: "Non hai i permessi necessari per caricare file",
            duplicateOf: "Hai già caricato questo file!",
            duplicated: "Questo file ha dei duplicati!",
            move: "Sposta",
            moveHere: "Sposta qui",
            statusesTitle: "Stato",
            statuses: {
                READY: "Pronti per l'estrazione",
                TAGGING: "In coda",
                ERROR: "In errore",
                ARCHIVED: "Archiviati",
                INDEXING: "In estrazione",
                INDEXED: "Pronti per l'analisi"
            },
            type: {
                FOLDER: "Cartella",
                DOCUMENT: "Documento"
            },
            uniquenessTitle: "Duplicati",
            uniqueness: {
                UNIQUE: "Senza duplicati",
                DUPLICATED: "Doppioni"
            },
            searchResult: "I tuoi risultati appariranno qui",
            searchHits: "di {n} risultati"
        },
        frequencies: {
            EVERY_YEAR: "Annuale",
            EVERY_MONTH: "Mensile",
            EVERY_TWO_MONTH: "Bimestrale",
            EVERY_THREE_MONTH: "Trimestrale",
            EVERY_SIX_MONTH: "Semestrale",
            EVERY_WEEK: "Settimanale",
            EVERY_DAY: "Giornaliera",
            required: "Frequenza e data sono obbligatorie"
        },
        permissions: {
            sharableAccounts: "Seleziona uno o più account",
            noSharableAccounts: "Non ci sono account con cui condividere la risorsa",
            accountAdd: "Aggiungi",
            unshared: "Rimuovi la condivisione",
            noDataMessage: "Non esiste nessun account che rispetti i parametri di ricerca",
            role: "Ruolo",
            roles: {
                OWNER: {
                    title: "Propietario",
                    description: "Proprietario della risorsa"
                },
                MODERATOR: {
                    title: "Gestore",
                    description: "l'utente può modificare la risorsa e gestire le condivisioni"
                },
                WRITER: {
                    title: "Modificatore",
                    description: "l'utente può modificare la risorsa ma non condividerla"
                },
                READER: {
                    title: "Visualizzatore",
                    description: "l'utente può visualizzare la risorsa"
                },
                NONE: {
                    title: "Nessuno",
                    description: "Non può visualizzare ne modificare"
                }
            }
        },
        analyses: {
            noDataMessage: "Non sei abilitato a nessuna analisi che rispetti i parametri di ricerca",
            noParameters: "Non servono parametri aggiuntivi per questo report",
            search: "Cerca analisi",
            delete: {
                title: "Elimina analisi progetto",
                question:
                    "Vuoi eliminare l'analisi e tutti i permessi agli account associati nel progetto? Attenzione, l'azione è irreversibile!"
            },
            enabled: "Abilitata",
            enable: "Abilita",
            disabled: "Disabilitata",
            disable: "Disabilita"
        },
        surveys: {
            title: "Questionario",
            edit: "Modifica questionario",
            noDataMessage: "Non sei abilitato a nessun questionario che rispetti i parametri di ricerca",
            answer: "Rispondi",
            search: "Cerca questionario",
            selectorDialog: {
                firstStep: {
                    title: "Seleziona il questionario",
                    subTitle: "Scegli il questionario a cui vuoi rispondere"
                },
                secondStep: {
                    title: "Rispondi",
                    subTitle: "Rispondi alle domande del questionario",
                    resetAnswers: "Reset risposte"
                },
                thirdStep: {
                    title: "Salvataggio completato",
                    subTitle: "Abbiamo salvato le tue risposte con successo"
                }
            }
        },
        error: {
            oops: "Ooops!",
            generic: "Qualcosa è andato storto",
            backToHome: "Torna alla home"
        },
        backoffice: {
            title: "Backoffice",
            accounts: "Account",
            workspaces: "Progetti",
            analyses: "Analisi",
            surveys: "Questionari",
            selectWorkspace: "Seleziona un progetto",
            info: "Crea account, progetti e abilita analisi",
            sync: "Sincronizza",
            lastModified: "Ultimo aggiornamento",
            firstLogin: {
                manage: "Gestici email di primo accesso",
                text: "L'ultima email di primo accesso a '{email}' é stata inviata in data {date}",
                subText:
                    "Sei sicuro di inviare una nuova email di primo accesso? Le impostazioni di sicurezza, come il token per l'autenticazione a due fattore, verranno CANCELLATE. L'operazione é irreversibile."
            }
        },
        wsChooser: {
            title: "Progetti",
            search: "Cerca",
            noDataMessage: "Non hai nessun progetto che rispetti i parametri di ricerca"
        },
        editor: {
            addImage: "Inserisci immagine",
            setLink: "Inserisci link"
        },
        reportViews: {
            download: "Scarica report visualizzazioni",
            description: "Report"
        },
        home: {
            title: "La tua area di lavoro",
            info: "Riepilogo dei Report e Archivi presenti nell'area di lavoro",
            noPinnedReports: "Non sono presenti report in evidenza in questa area di lavoro.",
            sharedWithMeSubtitle:
                "In questa sezione trovi il riepilogo di tutti i Report e gli Archivi che ti sono stati condivisi.",
            ownedSubtitle:
                "In questa sezione trovi il riepilogo di tutti i Report e gli Archivi che hai creato in questa area di lavoro.",
            noReportsSharedWithMe: "Nessun report condiviso.",
            noVaultsSharedWithMe: "Nessun archivio condiviso.",
            noReportsOwned: "Nessun report creato",
            noVaultsOwned: "Nessun archivio creato"
        },
        analysisTester: {
            title: "Tester parametri analisi",
            info: "Scrivi JSON schema, UI schema e valori di default per verificare il rendering dei parametri",
            jsonSchema: "JSON schema",
            uiSchema: "UI schema",
            defaultValues: "Valori di default",
            render: "Renderizza",
            preview: "Anteprima",
            parametrized: "Parametrizzata",
            validate: "Valida",
            valid: "I parametri sono validi",
            invalid: "I parametri non sono validi",
            modelValue: "Valore corrente",
            format: "Formatta JSON",
            invalidJson: "JSON non valido",
            notAnObject: "Il valore deve essere un oggetto JSON",
            renderError: "Errore durante il rendering",
            noPreview: "Premi Renderizza per visualizzare l'anteprima"
        },
        jsonEditor: {
            compact: "Compatta",
            expand: "Espandi",
            compactAll: "Compatta tutto",
            expandAll: "Espandi tutto",
            copy: "Copia negli appunti",
            copied: "Copiato!",
            copyFailed: "Impossibile copiare"
        }
    },
    en: {
        name: "Name",
        pin: "Pin",
        unpin: "Unpin",
        reload: "Reload",
        loadingReportAndAnalysis: "Loading...",
        unselect: "Unselect all",
        selectPage: "Select page",
        download: "Download",
        logout: "Logout",
        sortBy: "Sort by:",
        filterBy: "Filter by:",
        close: "Close",
        cancel: "Cancel",
        apply: "Apply",
        search: "Search",
        open: "Open",
        share: "Share",
        filter: "Filter",
        clearFilter: "Clear filters",
        create: "Create",
        add: "Add",
        rename: "Rename",
        modify: "Modify",
        confirm: "Confirm",
        selectAll: "Select all",
        sorted: "Sorting",
        selectDate: "Select Date",
        export: "Export",
        noData: "No data to display",
        noDataSuggestion: "No data available. Please try another filter or search.",
        save: "Save",
        projects: "Projects",
        next: "Next",
        back: "Back",
        choose: "Choose",
        analyze: "Analyze",
        title: "Title",
        description: "Description",
        frequency: "Frequency",
        delete: "Delete",
        fieldRequired: "Field required",
        emailRequired: "The email must be valid",
        fieldTooLong: "Field too long",
        experimental: "Beta",
        selected: "Selected",
        page: "Page",
        pageOf: "of",
        totalRows: "Total rows",
        enable: "Enable",
        disable: "Disable",
        showAdvanceOptions: "Show advanced options",
        general: "General",
        security: "Security",
        strongConfirmationText: "Type the word",
        strongConfirmationSubtext: "in the following area to confirm",
        sharedWithMe: "Shared with me",
        owned: "Created",
        about: {
            title: "About",
            name: "Application",
            version: "Version",
            commit: "Commit",
            buildTime: "Build time",
            buildId: "Build ID",
            upToDate: "You are using the latest version",
            updateAvailable: "A new version is available",
            checking: "Checking for updates...",
            checkNow: "Check for updates",
            copy: "Copy info",
            copied: "Copied!"
        },
        account: {
            title: "Account",
            email: "Email",
            name: "Name",
            surname: "Surname",
            language: "Language",
            defaultProject: "Default Project",
            enabled: "Enabled",
            disabled: "Disabled",
            create: "Create account",
            search: "Search account",
            created: "Created",
            firstLoginOk: "Logged in",
            firstLoginNotOk: "Not logged yet",
            generalSettings: "General settings",
            securitySettings: "Security settings",
            softwareToken: {
                enableTitle: "Enable MFA with authenticator app",
                enable: "Enable MFA",
                disableTitle: "Disable MFA with authenticator app",
                disableText:
                    "You are about to disable two-factor authentication. This will reduce the security of your account, making it more vulnerable to unauthorized access. You can re-enable two-factor authentication at any time in your security settings.",
                title: "Authenticator app",
                subtitle:
                    "Use an authentication app or browser extension to obtain two-factor authentication codes when prompted.",
                enabledAtDate: "Enabled at",
                deviceName: "Device name",
                setupTitle:
                    "Increase your account security by enabling two-factor authentication. In addition to your password, you will need to enter a verification code generated by your authentication app each time you log in. Follow these simple steps to complete the setup.",
                qrValue: "Secret key",
                qrUrl: "URL",
                scanQr: "Scan the QR code",
                scanQrSubtitle:
                    "Use an authentication app (Google Authenticator, Microsoft Authenticator, or any other app) compatible with TOTP to scan the QR code shown here. The app will automatically generate the verification codes needed to access your account.",
                deviceNaming: "Assign a device name",
                deviceNamingSubtitle:
                    "Give the device or app you are setting up a recognizable name (for example: “Mario's iPhone,” “Google Authenticator,” “Company Tablet”). This will help you easily identify this authentication method.",
                deviceNamingPlaceholder: "Company Tablet",
                verifyDevice: "Verify the device",
                verifyDeviceSubtitle:
                    "Enter the 6-digit code generated by your authentication app to complete the setup. The code refreshes every 30 seconds, so be sure to enter it before it expires."
            }
        },
        language: {
            it: "Italiano",
            en: "English"
        },
        dialog: {
            title: "Title"
        },
        confirmDialog: {
            title: "Confirm",
            question: "Are you sure to proceed? Be careful, the action may be irreversible."
        },
        workspaces: {
            info: "Choose the project",
            title: "Projects",
            in: "You are in project:",
            created: "Created on:",
            sortCreated: "Creation date",
            lastUpload: "Last upload",
            name: "Name",
            description: "Description",
            noDataMessage: "You have no projects that match the search criteria",
            noWorkspace: "We are preparing your project...",
            create: "Create project",
            modify: "Edit project"
        },
        notifications: {
            title: "Notifications",
            readAll: "Read all",
            goToReport: "Go to report",
            goToVault: "Go to vault",
            name: "Title",
            created: "Date",
            isIn: "Present in",
            subtitles: {
                REPORT_SHARED: "A report has been shared with you",
                VAULT_SHARED: "You have a new vault to view"
            },
            noDataMessage: "You have no notifications that match the search criteria"
        },
        reports: {
            title: "Reports",
            info: "View and create analysis reports",
            search: "Search reports",
            create: "Create report",
            modify: "Rename",
            reschedule: "New version",
            replace: "Modify",
            youAreTheAuthor: "You are the author of this report",
            writtenBy: "Written by",
            createdOn: "Created on",
            statuses: {
                title: "Status",
                CREATED: "Created",
                IN_PROGRESS: "In Progress",
                FAILED: "Under review",
                descriptions: {
                    IN_PROGRESS: "The report is in progress. Please wait a moment.",
                    FAILED: "Ooops... an error occurred. Our technicians are working to resolve the issue as soon as possible."
                }
            },
            selectorDialog: {
                firstStep: {
                    title: "Select analysis",
                    subTitle: "Choose what you want to analyze"
                },
                secondStep: {
                    title: "Set parameters",
                    subTitle: "Set parameters to customize your analysis",
                    resetParameters: "Reset parameters"
                }
            },
            printPdf: "Print PDF",
            printPdfNotFound: "The PDF version of this report will be available soon",
            delete: {
                title: "Delete report",
                question: "Do you want to delete the report? Warning: This action is irreversible!"
            },
            noDataMessage: "You have no reports to view that match the search criteria",
            comments: "Comments",
            scrollToTop: "Scroll to top",
            options: "Options",
            saveParameters: "Store parameters",
            viewGrid: "Show grid",
            viewList: "Show list",
            views: "view | views",
            noViews: "No views",
            newShaperAi: "Create a report with Shaper AI",
            chat: {
                open: "Open chat",
                close: "Close chat",
                empty: "No messages in this chat",
                placeholder: "Ask to Shaper...",
                fileSizeError: "The following files exceed the 10 MB limit and were not attached: {files}",
                fileTypeError: "The following files are not PDF and were not attached: {files}",
                attachment: "Attachment | Attachments",
                selectAttachment: "Select attachment/s",
                selectVault: "Select vault",
                review: "Review selection"
            },
            noMoreReports: "No more reports to display"
        },
        vaults: {
            title: "Vaults",
            info: "Upload and view your documents",
            vault: "Vault | Vaults",
            search: "Search vaults",
            searchInVault: "Search in vault",
            create: "Create vault",
            modify: "Update vault",
            lastModified: "Last modified",
            lastUpload: "Last upload",
            uploaded: "Uploaded",
            name: "Name",
            description: "Description",
            creationDate: "Creation date",
            size: "Size",
            state: "State",
            noVaults: "You have no vaults to consult that match the search criteria",
            downloadVault: "Download vault",
            deleteVaultTitle: "Delete vault",
            deleteVaultText: "Do you want to delete this vault? Warning: This action is irreversible!",
            dragAndDrop: "Drag files into the table to start uploading",
            deleteFileTitle: "Delete item",
            deleteFileText: "Do you want to delete the selected items? Warning: This action is irreversible!",
            elements: "elements",
            runTagger: "Start extraction",
            noDocuments: "This vault is empty",
            deleteDenied: "You have to empty the vault before you can delete it",
            noMoreVaults: "No more vaults to display"
        },
        tags: {
            title: "Tags",
            GENERAL: "GENERAL",
            TLC_FIXED: "TLC FIXED",
            TLC_MOBILE: "TLC MOBILE",
            ELECTRICITY: "ELECTRICITY",
            GAS: "GAS",
            WATER: "WATER",
            CLEANING: "CLEANING",
            MATERIAL: "MATERIALS",
            TRANSPORT: "TRANSPORTATION",
            HUMAN_RESOURCES: "HR",
            HUMAN_RESOURCES_INPS: "INPS",
            HUMAN_RESOURCES_INAIL: "INAIL",
            WAREHOUSE: "Warehouse",
            LOGISTIC: "Logistics",
            WASTE_DISPOSAL: "Waste disposal",
            CAR_FLEET: "Car fleet",
            SUSTAINABILITY: "Sustainability",
            ELECTRICITY_GAS: "ENERGIES",
            AI: "AI",
            AI_ELECTRICITY: "AI ELECTRICITY",
            AI_GAS: "AI GAS",
            AI_TRANSPORT: "AI TRANSPORT",
            AI_TLC: "AI TLC",
            AI_INPS: "AI INPS",
            AI_INAIL: "AI INAIL"
        },
        files: {
            info: "View and upload files to the archive",
            ready: "There are no files ready for extraction | The file is ready for extraction | {n} files are ready for extraction",
            tagging:
                "There are no files queued for extraction | the file is queued for extraction | {n} files are queued for extraction",
            error: "There are no files in error | The file generated an error being extracted | {n} files generated an error being extracted",
            archived: "No archived files | The file is available in the vault | {n} files are available in the vault",
            indexed:
                "No files available for analysis | Data in the file is ready for analysis | Data in {n} files is ready for analysis",
            indexing: "No files being extracted | Extracting data from one file | Extracting data from {n} files",
            createFolder: "Create folder",
            renameFolder: "Rename folder",
            folderName: "Folder name",
            upload: "Upload",
            preparingFiles: "Preparing files for upload",
            emptyFolder: "This folder is empty",
            note: "Tag",
            updateNote: "Set tag",
            multipleNotes: "Multiple values",
            setStatus: {
                archived: "Set to archived",
                indexed: "Set to indexed",
                indexing: "Set to indexing"
            },
            uploadDenied: "You do not have the necessary permissions to upload files",
            duplicated: "This file has duplicates!",
            duplicateOf: "You have already uploaded this file!",
            move: "Move",
            moveHere: "Move here",
            statusesTitle: "State",
            statuses: {
                READY: "Ready for extraction",
                TAGGING: "Queued",
                ERROR: "Error",
                ARCHIVED: "Archived",
                INDEXING: "In extraction",
                INDEXED: "Ready for analysis"
            },
            type: {
                FOLDER: "Folder",
                DOCUMENT: "Document"
            },
            uniquenessTitle: "Duplicates",
            uniqueness: {
                UNIQUE: "Without duplicates",
                DUPLICATED: "Duplicated"
            },
            searchResult: "Your result will appear here",
            searchHits: "of {n} results"
        },
        frequencies: {
            EVERY_YEAR: "Yearly",
            EVERY_MONTH: "Monthly",
            EVERY_TWO_MONTH: "Bimonthly",
            EVERY_THREE_MONTH: "Quarterly",
            EVERY_SIX_MONTH: "Semi-annually",
            EVERY_WEEK: "Weekly",
            EVERY_DAY: "Daily",
            required: "Required"
        },
        permissions: {
            sharableAccounts: "Select one or more accounts.",
            noSharableAccounts: "There are no accounts to share the resource with",
            accountAdd: "Add",
            unshared: "Remove sharing.",
            noDataMessage: "There are no accounts that match the search criteria",
            role: "Role",
            roles: {
                OWNER: {
                    title: "Owner",
                    description: "owner of the resource"
                },
                MODERATOR: {
                    title: "Moderator",
                    description: "the user can edit the resource and manage shares"
                },
                WRITER: {
                    title: "Writer",
                    description: "the user may modify the resource but not share it"
                },
                READER: {
                    title: "Reader",
                    description: "the user may view the resource"
                },
                NONE: {
                    title: "None",
                    description: "cannot view or modify"
                }
            }
        },
        analyses: {
            noDataMessage: "You are not authorized for any analyses that match the search criteria",
            noParameters: "No additional parameters are needed for this report",
            search: "Search analyses",
            delete: {
                title: "Delete project analysis",
                question:
                    "Do you want to delete the analysis and all permissions to associated accounts in the project? Warning, the action is irreversible!"
            }
        },
        surveys: {
            title: "Surveys",
            edit: "Edit survey",
            noDataMessage: "You are not authorized for any analyses that match the search criteria",
            answer: "Answer",
            search: "Search surveys",
            selectorDialog: {
                firstStep: {
                    title: "Select survey",
                    subTitle: "Choose the survey you want to fill"
                },
                secondStep: {
                    title: "Answer",
                    subTitle: "Answer the survey questions",
                    resetAnswers: "Reset answers"
                },
                thirdStep: {
                    title: "Saved successfully",
                    subTitle: "We saved your answers successfully"
                }
            }
        },
        error: {
            oops: "Ooops!",
            generic: "Something went wrong",
            backToHome: "Back to home"
        },
        backoffice: {
            title: "Backoffice",
            accounts: "Accounts",
            workspaces: "Projects",
            analyses: "Analysis",
            surveys: "Surveys",
            selectWorkspace: "Select a project",
            info: "Create accounts, projects and enable analysis",
            sync: "Sync",
            lastModified: "Last update"
        },
        wsChooser: {
            title: "Projects",
            search: "Search",
            noDataMessage: "You have no project that meets the search parameters"
        },
        editor: {
            addImage: "Add image",
            setLink: "Set link"
        },
        reportViews: {
            download: "Download report views",
            description: "Report"
        },
        home: {
            title: "Your workspace",
            info: "Summary of Reports and Vaults in this workspaces",
            noPinnedReports: "There is no pinned reports in this workspace.",
            sharedWithMeSubtitle: "In this section there is a summary of all reports and vault shared with you.",
            ownedSubtitle:
                "In this section there is a summary of all reports and vault that you created in this workspace.",
            noReportsSharedWithMe: "Nessun report condiviso.",
            noVaultsSharedWithMe: "Nessun archivio condiviso.",
            noReportsOwned: "Nessun report creato",
            noVaultsOwned: "Nessun archivio creato"
        },
        analysisTester: {
            title: "Analysis parameters tester",
            info: "Write JSON schema, UI schema and default values to check how parameters are rendered",
            jsonSchema: "JSON schema",
            uiSchema: "UI schema",
            defaultValues: "Default values",
            render: "Render",
            preview: "Preview",
            parametrized: "Parametrized",
            validate: "Validate",
            valid: "Parameters are valid",
            invalid: "Parameters are not valid",
            modelValue: "Current value",
            format: "Format JSON",
            invalidJson: "Invalid JSON",
            notAnObject: "The value must be a JSON object",
            renderError: "Error while rendering",
            noPreview: "Press Render to see the preview"
        },
        jsonEditor: {
            compact: "Compact",
            expand: "Expand",
            compactAll: "Compact all",
            expandAll: "Expand all",
            copy: "Copy to clipboard",
            copied: "Copied!",
            copyFailed: "Copy failed"
        }
    }
};
